import { Skeleton } from "@mui/material";
import { styled } from "@mui/system";
import { Link as RouterLink } from "react-router-dom";
import RightArrowIcon from "src/icons/portfolio/RightArrowIcon";

export const ReferLinkWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",
  zIndex: 1,
  width: "100%",
}));

export const ReferLinkHeader = styled(RouterLink)({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "6px",
  fontSize: "16px",
  fontWeight: 600,
  width: "100%",
  textDecoration: "none",
  color: "inherit",
  cursor: "pointer",
});

export const ReferLinkSubHeader = styled("div")({});

export const ReferLinkSubHeaderIcon = styled("div")({
  cursor: "pointer",
});

export const ReferLinkText = styled("div")({
  color: "#790202",
  fontSize: "12px",
});

export const ReferShareLink = styled("div")({
  display: "flex",
  fontSize: "12px",
  width: "100%",
  padding: "2px 2px 2px 8px",
  justifyContent: "space-between",
  flex: "1 0 0",
  alignItems: "center",
  gap: "4px",
  borderRadius: "16px",
  border: "1px dashed  #002035",
  userSelect: "none",
});

export const ReferShareButton = styled("div")(({ theme }) => ({
  display: "flex",
  padding: " 4px 12px",
  alignItems: "center",
  gap: "4px",
  borderRadius: "16px",
  background: "#002035",
  color: "#FFF",
  cursor: "pointer",

  /* Shadow (MD)/Standard */
  boxShadow: "0px 8px 16px 0px rgba(216, 216, 218, 0.90)",

  "&:hover": {
    background: "#4E7086",
  },

  "&:focus": {
    backgroundColor: "#E8F6FF",
    color: "#002035",
  },
}));

const OptInReferral = ({
  handleOptIn,
  isLoading,
}: {
  handleOptIn: () => void;
  isLoading: boolean;
}) => {
  if (isLoading) return <Skeleton variant="rounded" width={"100%"} height={"121px"} />;

  return (
    <ReferLinkWrapper>
      <ReferLinkHeader to="/refer-a-friend">
        <ReferLinkSubHeader>Interested in our refer a friend program?</ReferLinkSubHeader>
        <ReferLinkSubHeaderIcon>
          <RightArrowIcon />
        </ReferLinkSubHeaderIcon>
      </ReferLinkHeader>
      <ReferLinkText>Create your very own referral code to share today</ReferLinkText>
      <ReferShareLink>
        <div style={{ filter: "blur(2px)" }}>app.calebandbrown.com/signup</div>
        <ReferShareButton onClick={handleOptIn}>Create Code</ReferShareButton>
      </ReferShareLink>
    </ReferLinkWrapper>
  );
};

export default OptInReferral;
